import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../Box/index.js";
import { Icon } from "../Icon/index.js";
import { Typography } from "../Typography/index.js";
const ToTopButton = (t0)=>{
    const $ = c(4);
    const { scrollToStart } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx(Icon, {
            name: "arrow_up_outline",
            size: "20",
            color: "original.brand.primary"
        });
        t2 = /*#__PURE__*/ jsx(Typography, {
            variant: "subtitle1",
            color: "original.brand.primary",
            children: "Наверх"
        });
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== scrollToStart) {
        t3 = /*#__PURE__*/ jsxs(Box, {
            position: "fixed",
            display: "flex",
            alignItems: "center",
            zIndex: 1000,
            bottom: 20,
            bgcolor: "bg.light.primary",
            radius: "m",
            boxShadow: "0px 2px 8px 0px rgba(0,26,77,0.10), 0px 6px 28px 0px rgba(0,26,77,0.12) !important",
            onClick: scrollToStart,
            py: "8",
            px: "16",
            cursor: "pointer",
            children: [
                t1,
                t2
            ]
        });
        $[2] = scrollToStart;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
export { ToTopButton };
